import { createFeatureSelector, createSelector } from "@ngrx/store";
import { HeaderState } from "./header.models";
import { RouterReducerState } from "@ngrx/router-store";

export const selectHeader = createFeatureSelector<HeaderState>('header');
export const selectRouter = createFeatureSelector<RouterReducerState>('router');

export const selectLocationOptions = createSelector(
    selectHeader,
    (state) => state.locations
);

export const selectLocation = createSelector(
    selectHeader,
    (state) => state.selectedLocation
);

export const selectNotifications = createSelector(
    selectHeader,
    (state) => state.notifications
);

export const selectMenuItems = createSelector(
    selectHeader,
    (state) => state.menuItems
);